/* eslint-disable
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

function getFlankingPrimers(sequence, fragmentResult) {
  if (!fragmentResult.primerFlanked()) {
    return [null, null];
  }
  const pair = sequence.primerPairs().get(fragmentResult.primerPairID());
  // Even though primerFlanked should return false if the primer pair is detached, in certain codepaths
  // (e.g. detaching a single primer with the assembly tab open) the primerPairs() collection gets updated
  // sans primer pair while the fragment's client-side model still thinks it has a primer pair.
  // We handle this by just returning early.
  if (pair == null) {
    return [null, null];
  }
  return pair.getPrimers(sequence.sequencePrimers());
}

function getJunctions(sequence) {
  const fragmentResults = sequence.fragmentResults();
  return fragmentResults.map((fragmentResult, i) => {
    const nextFragmentResult = fragmentResults.at((i + 1) % fragmentResults.length);
    const [fwd, rev] = Array.from(getFlankingPrimers(sequence, fragmentResult));
    const [nextFwd, nextRev] = Array.from(getFlankingPrimers(sequence, nextFragmentResult));
    return [fragmentResult.end(), nextFragmentResult.start(), nextFwd, rev];
  });
}

function validSpacerOrder(slots) {
  const usesEnzymeArray = slots.map((slot) => !slot.isEmpty() && slot.singleFragment().enzymeIDs() != null);
  for (let i = 0; i < slots.models.length; i++) {
    const slot = slots.models[i];
    if (!slot.isSpacer()) {
      continue;
    }
    const prevIndex = i === 0 ? slots.length - 1 : i - 1;
    const nextIndex = (i + 1) % slots.length;
    if (usesEnzymeArray[prevIndex] && usesEnzymeArray[nextIndex]) {
      // Spacer slot cannot be between two digest-cut fragments.
      return false;
    }
  }
  return true;
}

function addPrimerNameSuffixes(sequencePrimers) {
  const totalPrimerNameCounts = _.countBy(sequencePrimers.models, (primer) => primer.name());
  const currentPrimerNameCounts = {};
  sequencePrimers.each((primer) => {
    const primerName = primer.name();
    if (totalPrimerNameCounts[primerName] < 2) {
      return;
    }
    // Add numerical suffix to deduplicate primer names.
    // eslint-disable-next-line benchlint/no-in-operator
    if (!(primerName in currentPrimerNameCounts)) {
      currentPrimerNameCounts[primerName] = 0;
    }
    currentPrimerNameCounts[primerName]++;
    primer.set({name: `${primerName} (${currentPrimerNameCounts[primerName]})`});
  });
}

const basePlugin = {
  assemblyType: null,

  attachTabs(sequence, buffer) {},

  // Returns {warnings=[], errors=[]} for assembly
  checkAssembly(assembly) {
    throw new Error(`Did not expect checkAssembly to be called on basePlugin - \
make sure it's been implemented`);
  },

  // Based on the sequence parents, returns an array of [color, 5' start, 3' start] to color the
  // sequence regions, with one per parent.
  getFragmentResultPieces(sequence) {
    return sequence
      .fragmentResults()
      .map((fragmentResult) => [fragmentResult.color(), fragmentResult.start(), fragmentResult.end()]);
  },

  isFlankingPrimer(sequence, primer) {
    if (sequence.finalized()) {
      return false;
    }
    const primerPairs = sequence.primerPairs();
    const primers = sequence.sequencePrimers();
    return (
      sequence
        .fragmentResults()
        .chain()
        .map((fragmentResult) => {
          if (fragmentResult.primerFlanked()) {
            return getFlankingPrimers(sequence, fragmentResult);
          }
          return [];
        })
        .flatten()
        .compact()
        .find((flankingPrimer) => flankingPrimer.id === primer.id)
        .value() != null
    );
  },

  canDelete(sequence, selection, errback) {
    return true;
  },

  // Determines whether or not we can insert at a selection (if no range is selected)
  // or initiate a replace at that selection (if a range is selected). We say "initiate" because
  // `canReplace` can still reject the change.
  canEditSelection(sequence, selection, errback) {
    return true;
  },

  // Checks whether the current selection can be replaced by specified bases.
  canReplace(sequence, selection, errback) {
    return true;
  },

  didDelete(sequence, selection, bases, callback, errback) {},

  didInsert(sequence, selection, bases, callback, errback) {},

  didReplace(sequence, selection, bases, callback, errback) {},

  shouldOpenSequenceFiles() {
    return true;
  },
};

export {addPrimerNameSuffixes, basePlugin, getFlankingPrimers, getJunctions, validSpacerOrder};
